import { defineComponent, provide } from 'vue';
import { horizontalLayoutKey } from '#layers/block-engine/utils/block/const';

export default defineComponent({
	setup(props, { slots }) {
		provide(horizontalLayoutKey, true);

		return () => slots.default?.();
	},
});
